/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import * as Types from '../../../types/schema.generated';

import gql from 'graphql-tag';
import { SettingsPagePlannerSpecialtyFragmentDoc, SettingsPagePlannerFragmentDoc } from '../../SettingsPage/SettingsPage.generated';
import * as VueApolloComposable from '@vue/apollo-composable';
import * as VueCompositionApi from 'vue';
export type ReactiveFunction<TParam> = () => TParam;
export type Channel =
  /** 中国銀行 */
  | 'CHUGOKU_GINKO'
  /** ファミペイ */
  | 'FAMIPAY'
  /** 400F */
  | 'FOUR_HUNDRED_F'
  /** 400F 保険比較 */
  | 'FOUR_HUNDRED_F_INSURANCE_COMPARISON'
  /** はなさく生命 */
  | 'HANASAKU'
  /** ほけんの窓口 */
  | 'HOKEN_NO_MADOGUCHI'
  /** JCB */
  | 'JCB'
  /** ゆうちょ銀行 */
  | 'JP_BANK'
  /** きらぼし銀行 */
  | 'KIRABOSHI'
  /** ライフプラザパートナーズ */
  | 'LIFE_PLAZA'
  /** メットライフ生命 */
  | 'MET_LIFE'
  /** みんかぶ */
  | 'MINKABU'
  /** マネーフォワード */
  | 'MONEY_FORWARD'
  /** ninpath */
  | 'NINPATH'
  /** ニッセイアセットマネジメント */
  | 'NISSEI_AM'
  /** オカネコ */
  | 'OKANEKO'
  /** オカネコ転職 */
  | 'OKANEKO_TENSHOKU'
  /** OKB */
  | 'OKB'
  /** オリックス銀行 */
  | 'ORIX_BANK'
  /** Ponta */
  | 'PONTA'
  /** 楽天証券 */
  | 'RAKUTEN'
  /** 楽天証券インハウスアドバイザー */
  | 'RAKUTEN_IN_HOUSE_ADVISOR'
  /** 楽天証券の運用相談 */
  | 'RAKUTEN_UNYOU_SOUDAN'
  /** SBI証券 */
  | 'SBI'
  /** SBIマネープラザ */
  | 'SBI_MONEY_PLAZA'
  /** SBI証券の運用相談 */
  | 'SBI_UNYOU_SOUDAN'
  /** 三井住友カード */
  | 'SMCC'
  /** トヨタカローラ */
  | 'TOYOTA_COROLLA'
  /** Vitalityスマート */
  | 'VITALITY_SMART'
  /** Yahoo! JAPAN */
  | 'YAHOO'
  /** 財形住宅金融 */
  | 'ZAIKEI_JUTAKU_KINYU';

export type Prefecture =
  | 'Aichi'
  | 'Akita'
  | 'Aomori'
  | 'Chiba'
  | 'Ehime'
  | 'Fukui'
  | 'Fukuoka'
  | 'Fukushima'
  | 'Gifu'
  | 'Gunma'
  | 'Hiroshima'
  | 'Hokkaido'
  | 'Hyogo'
  | 'Ibaraki'
  | 'Ishikawa'
  | 'Iwate'
  | 'Kagawa'
  | 'Kagoshima'
  | 'Kanagawa'
  | 'Kochi'
  | 'Kumamoto'
  | 'Kyoto'
  | 'Mie'
  | 'Miyagi'
  | 'Miyazaki'
  | 'Nagano'
  | 'Nagasaki'
  | 'Nara'
  | 'Niigata'
  | 'Oita'
  | 'Okayama'
  | 'Okinawa'
  | 'Osaka'
  | 'Saga'
  | 'Saitama'
  | 'Shiga'
  | 'Shimane'
  | 'Shizuoka'
  | 'Tochigi'
  | 'Tokushima'
  | 'Tokyo'
  | 'Tottori'
  | 'Toyama'
  | 'Wakayama'
  | 'Yamagata'
  | 'Yamaguchi'
  | 'Yamanashi';

export type KarteUserFilteringItemListQueryVariables = Exact<{ [key: string]: never; }>;


export type KarteUserFilteringItemListQuery = { viewer: { channels: Array<{ id: Types.Channel, name: string }> }, planner: { id: string, name: string, slug: string, avatar: any, avatarUrl: string, cover: any, coverUrl: string | null, corporationId: string, branchIds: Array<string>, email: string, gender: string, birthday: DateString | null, availableTime: string, availableAreaCodes: Array<string>, role: string, comment: string, authorities: Array<string>, specialties: Array<{ id: string, name: string }> } | null, specialties: Array<{ id: string, name: string }> };

export type ChannelItemOnkarteUserFilteringItemListFragment = { id: Types.Channel, name: string };

export type FetchCitiesOnKarteUserFilterItemListQueryVariables = Exact<{
  prefecture: Types.Prefecture;
}>;


export type FetchCitiesOnKarteUserFilterItemListQuery = { getCitiesByPrefecture: Array<{ jisx0402: JISX0402, name: string }> };

export const ChannelItemOnkarteUserFilteringItemListFragmentDoc = gql`
    fragment ChannelItemOnkarteUserFilteringItemList on ChannelItem {
  id
  name
}
    `;
export const KarteUserFilteringItemListDocument = gql`
    query karteUserFilteringItemList {
  viewer {
    channels {
      ...ChannelItemOnkarteUserFilteringItemList
    }
  }
  planner {
    ...SettingsPagePlanner
  }
  specialties {
    ...SettingsPagePlannerSpecialty
  }
}
    ${ChannelItemOnkarteUserFilteringItemListFragmentDoc}
${SettingsPagePlannerFragmentDoc}
${SettingsPagePlannerSpecialtyFragmentDoc}`;

/**
 * __useKarteUserFilteringItemListQuery__
 *
 * To run a query within a Vue component, call `useKarteUserFilteringItemListQuery` and pass it any options that fit your needs.
 * When your component renders, `useKarteUserFilteringItemListQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useKarteUserFilteringItemListQuery();
 */
export function useKarteUserFilteringItemListQuery(options: VueApolloComposable.UseQueryOptions<KarteUserFilteringItemListQuery, KarteUserFilteringItemListQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<KarteUserFilteringItemListQuery, KarteUserFilteringItemListQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<KarteUserFilteringItemListQuery, KarteUserFilteringItemListQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<KarteUserFilteringItemListQuery, KarteUserFilteringItemListQueryVariables>(KarteUserFilteringItemListDocument, {}, options);
}
export function useKarteUserFilteringItemListLazyQuery(options: VueApolloComposable.UseQueryOptions<KarteUserFilteringItemListQuery, KarteUserFilteringItemListQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<KarteUserFilteringItemListQuery, KarteUserFilteringItemListQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<KarteUserFilteringItemListQuery, KarteUserFilteringItemListQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<KarteUserFilteringItemListQuery, KarteUserFilteringItemListQueryVariables>(KarteUserFilteringItemListDocument, {}, options);
}
export type KarteUserFilteringItemListQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<KarteUserFilteringItemListQuery, KarteUserFilteringItemListQueryVariables>;
export const FetchCitiesOnKarteUserFilterItemListDocument = gql`
    query fetchCitiesOnKarteUserFilterItemList($prefecture: Prefecture!) {
  getCitiesByPrefecture(prefecture: $prefecture) {
    jisx0402
    name
  }
}
    `;

/**
 * __useFetchCitiesOnKarteUserFilterItemListQuery__
 *
 * To run a query within a Vue component, call `useFetchCitiesOnKarteUserFilterItemListQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchCitiesOnKarteUserFilterItemListQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useFetchCitiesOnKarteUserFilterItemListQuery({
 *   prefecture: // value for 'prefecture'
 * });
 */
export function useFetchCitiesOnKarteUserFilterItemListQuery(variables: FetchCitiesOnKarteUserFilterItemListQueryVariables | VueCompositionApi.Ref<FetchCitiesOnKarteUserFilterItemListQueryVariables> | ReactiveFunction<FetchCitiesOnKarteUserFilterItemListQueryVariables>, options: VueApolloComposable.UseQueryOptions<FetchCitiesOnKarteUserFilterItemListQuery, FetchCitiesOnKarteUserFilterItemListQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<FetchCitiesOnKarteUserFilterItemListQuery, FetchCitiesOnKarteUserFilterItemListQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<FetchCitiesOnKarteUserFilterItemListQuery, FetchCitiesOnKarteUserFilterItemListQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<FetchCitiesOnKarteUserFilterItemListQuery, FetchCitiesOnKarteUserFilterItemListQueryVariables>(FetchCitiesOnKarteUserFilterItemListDocument, variables, options);
}
export function useFetchCitiesOnKarteUserFilterItemListLazyQuery(variables?: FetchCitiesOnKarteUserFilterItemListQueryVariables | VueCompositionApi.Ref<FetchCitiesOnKarteUserFilterItemListQueryVariables> | ReactiveFunction<FetchCitiesOnKarteUserFilterItemListQueryVariables>, options: VueApolloComposable.UseQueryOptions<FetchCitiesOnKarteUserFilterItemListQuery, FetchCitiesOnKarteUserFilterItemListQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<FetchCitiesOnKarteUserFilterItemListQuery, FetchCitiesOnKarteUserFilterItemListQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<FetchCitiesOnKarteUserFilterItemListQuery, FetchCitiesOnKarteUserFilterItemListQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<FetchCitiesOnKarteUserFilterItemListQuery, FetchCitiesOnKarteUserFilterItemListQueryVariables>(FetchCitiesOnKarteUserFilterItemListDocument, variables, options);
}
export type FetchCitiesOnKarteUserFilterItemListQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<FetchCitiesOnKarteUserFilterItemListQuery, FetchCitiesOnKarteUserFilterItemListQueryVariables>;